/**
 * This file contains the dark palette options for the theme.
 */

import { PaletteOptions } from "@mui/material";
import { primaryDark } from "./Colors";

export const DARK_PALETTE_OPTIONS: PaletteOptions = {
  primary: primaryDark,
};
